import { usePermissionsContext, useSignIn } from "@repo/auth";
import { Logo } from "@repo/ui/components/logo";
import { SignInForm } from "@repo/ui/components/sign-in-form";
import { createFileRoute, redirect, useRouter } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/login")({
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
  }),
  beforeLoad: ({ context, search }) => {
    const profile = context.medplum.getProfile();
    if (profile) {
      throw redirect({ to: search.redirect || "/dashboard" });
    }
  },
  component: LoginComponent,
});

function LoginComponent() {
  const router = useRouter();
  const navigate = Route.useNavigate();
  const search = Route.useSearch();
  const { refetch } = usePermissionsContext();

  const { signIn, loading, error } = useSignIn({
    projectId: import.meta.env.VITE_MEDPLUM_PROJECT_ID,
    onSuccess: async () => {
      await refetch();
      await router.invalidate();
      await navigate({ to: search.redirect || "/dashboard" });
    },
  });

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background">
      <SignInForm onSubmit={signIn} loading={loading} error={error}>
        <Logo variant="adaptive" className="h-8 w-auto" title={null} />
        <h1 className="text-sm font-medium uppercase tracking-widest text-muted-foreground">
          <span className="sr-only">MindForge </span>Provider
        </h1>
      </SignInForm>
    </div>
  );
}
